/* Exor Games - live Charlottetown hours for the shipping policy.

   Shopify renders /policies/shipping-policy itself, so the hours live in
   the policy body (Settings > Policies). Two shapes are handled:

   1. Markers (primary). The paste-ready body wraps the typed hours in
        <div data-xg-hours="pickup" id="xg-hours-pickup" class="xg-hours xg-hours-pickup">
        <div data-xg-hours="delivery" id="xg-hours-delivery" class="xg-hours xg-hours-delivery">
      found by data attribute, then id, then class (the rich-text editor
      may strip data-* on paste), first match per kind only. The marker's
      content - the typed fallback - is REPLACED.
   2. Legacy paragraphs, used only when no marker of that kind exists: the
      body as typed today,
        <p>Our in-store pickup hours are as follows:<br><br><meta charset="utf-8">
        <span>Monday 11am-7pm</span><br>...<span>Sunday 12pm-6pm</span><br><br>
        Please have your order confirmation ...</p>
      (likewise "Our Local Delivery hours are as follows:"). A paragraph
      qualifies only when its leading text is that sentence AND it holds at
      least five child <span>s starting with a weekday, with nothing but
      <br>, <meta> and whitespace between them. The sentence keeps its
      paragraph, the weekday run goes, the block is inserted as a SIBLING
      after the paragraph (a <div> cannot live inside a <p>) and whatever
      followed the run moves into a new paragraph after the block.

   On any page with either shape this asks the exor-binder worker once
   for /stores.json (Google Business hours per store, cached worker-side),
   picks the Charlottetown record (city field first, else the city named
   in the Google name/address - every location is "Exor Games" there) and
   renders a Monday..Sunday list:
     pickup   - the store's own hours ("10 am - 9 pm", "Closed",
                "Open 24 hours"), under an Open/Closed line in the
                locations strip's pill style;
     delivery - two hours after opening until 7 pm (5 pm on Sundays),
                clamped to the close; "No delivery" when that window is
                empty. A close past midnight counts as 24:00 first, so
                "1000-0000 next day" delivers 12 pm - 7 pm.
   The open/closed line is recomputed every minute from the cached feed
   (never refetched) and again when the tab regains focus. Open/closed,
   the next opening, the store-clock weekday and the "9 pm" formatting
   are copied from sections/locations-strip.liquid so the two can never
   disagree. A failed fetch, a missing record or a record without periods
   leaves the page exactly as served; a filled marker or paragraph is
   flagged data-xg-hours-live="true", so a second run is a no-op.

   The pure functions are exported when this file is loaded under
   CommonJS (the node harness); the DOM part runs only where a document
   exists (the browser, or the harness's jsdom). */
(function () {
  'use strict';

  var WORKER = 'https://exor-binder.nevski.workers.dev';
  var CITY = 'charlottetown';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];   // rows Monday..Sunday; day 0 = Sunday, as in the feed
  var WEEK = 7 * 1440;
  var DELIVERY_LAG = 120;                   // minutes after opening
  var DELIVERY_END = 19 * 60;               // 7 pm
  var DELIVERY_END_SUNDAY = 17 * 60;        // 5 pm
  var DELIVERY_NOTE = 'Delivery runs from two hours after opening until 7 pm (5 pm Sundays).';

  /* ---- Shared with sections/locations-strip.liquid (copied verbatim) */
  function isTime(t) { return /^\d{4}$/.test(String(t == null ? '' : t)); }
  function isDay(d) { return typeof d === 'number' && d >= 0 && d <= 6 && d === Math.floor(d); }
  function point(x) { return x && isDay(x.day) && isTime(x.time) ? x : null; }
  function mins(t) { return parseInt(t.slice(0, 2), 10) * 60 + parseInt(t.slice(2, 4), 10); }
  function fmt(t) {
    // "2100" -> "9 pm", "0930" -> "9:30 am"
    var h = parseInt(t.slice(0, 2), 10), m = parseInt(t.slice(2, 4), 10);
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + (h >= 12 ? 'pm' : 'am');
  }

  // Open/closed from the store's periods, evaluated in the STORE's clock:
  // shift "now" by the store's UTC offset and read it back with the UTC
  // getters, so the shopper's own timezone never leaks in. A period is
  // active when local (day, minute) lies in [open, close), with wrap-
  // around when the close is on a later day (or earlier in the week).
  function status(store, nowMs) {
    var hours = store && store.hours;
    if (!hours || !Array.isArray(hours.periods)) return null;
    var off = typeof store.utcOffsetMin === 'number' ? store.utcOffsetMin : 0;
    var d = new Date(nowMs + off * 60000);
    var day = d.getUTCDay();
    var cur = day * 1440 + d.getUTCHours() * 60 + d.getUTCMinutes();
    var periods = [], i, p;
    for (i = 0; i < hours.periods.length; i++) {
      p = hours.periods[i];
      if (p && point(p.open)) periods.push({ open: p.open, close: p.close == null ? null : point(p.close) });
    }
    for (i = 0; i < periods.length; i++) {
      p = periods[i];
      if (p.close === null) return { open: true, detail: '24 hours' };
      if (!p.close) continue;
      var o = p.open.day * 1440 + mins(p.open.time);
      var c = p.close.day * 1440 + mins(p.close.time);
      var len = (c - o + WEEK) % WEEK; if (len === 0) len = WEEK;
      if ((cur - o + WEEK) % WEEK < len) return { open: true, detail: 'closes ' + fmt(p.close.time) };
    }
    var best = null, bestRel = WEEK + 1;
    for (i = 0; i < periods.length; i++) {
      p = periods[i];
      var rel = (p.open.day * 1440 + mins(p.open.time) - cur + WEEK) % WEEK;
      if (rel < bestRel) { bestRel = rel; best = p; }
    }
    if (!best) return { open: false, detail: '' };
    var today = best.open.day === day && bestRel < 1440;
    // Show the whole window, not just the opening time: "opens 10 am - 6 pm"
    // answers "how late are you open" without a second click. When the next
    // opening is not today, the day leads so the two times stay together.
    var span = fmt(best.open.time) + (best.close ? ' – ' + fmt(best.close.time) : '');
    return { open: false, detail: 'opens ' + (today ? '' : DAYS[best.open.day] + ' ') + span };
  }

  /* ---- This file ---------------------------------------------------- */

  // Store-local weekday (0 = Sunday) for an instant, on the store's clock.
  function storeDay(store, nowMs) {
    var off = store && typeof store.utcOffsetMin === 'number' ? store.utcOffsetMin : 0;
    return new Date(nowMs + off * 60000).getUTCDay();
  }

  // Minutes since midnight -> "9 pm" / "9:30 am". Values at or past 1440
  // wrap, so a 24:00 close prints as "12 am" and 26:00 as "2 am".
  function fmtMin(m) {
    m = ((m % 1440) + 1440) % 1440;
    var h = Math.floor(m / 60), mm = m % 60;
    return fmt((h < 10 ? '0' : '') + h + (mm < 10 ? '0' : '') + mm);
  }

  // Google periods -> [{ day, open, close }] in minutes on the OPEN day's
  // clock. close === null is open 24 hours; a close on a later day (or at
  // or before the open time) lands past 1440, so "1000 - 0000 next day"
  // becomes 600..1440. Malformed entries are dropped. Sorted by day, then
  // open, so split days read in order.
  function periods(hours) {
    var out = [], i, p, o, c;
    if (!hours || !Array.isArray(hours.periods)) return out;
    for (i = 0; i < hours.periods.length; i++) {
      p = hours.periods[i];
      if (!p || !point(p.open)) continue;
      o = mins(p.open.time);
      if (p.close == null) { out.push({ day: p.open.day, open: o, close: null }); continue; }
      if (!point(p.close)) continue;
      c = mins(p.close.time) + 1440 * ((p.close.day - p.open.day + 7) % 7);
      if (c <= o) c += 1440;
      out.push({ day: p.open.day, open: o, close: c });
    }
    out.sort(function (a, b) { return a.day - b.day || a.open - b.open; });
    return out;
  }

  // Seven rows, Monday..Sunday. `span(period, day)` renders one period's
  // text ('' to skip it); a day with nothing to show gets `empty`.
  function rowsFor(hours, empty, span) {
    var ps = periods(hours), rows = [], i, j, d, parts, s;
    for (i = 0; i < WEEK_ORDER.length; i++) {
      d = WEEK_ORDER[i];
      parts = [];
      for (j = 0; j < ps.length; j++) {
        if (ps[j].day !== d) continue;
        s = span(ps[j], d);
        if (s) parts.push(s);
      }
      rows.push({ day: d, name: DAY_NAMES[d], text: parts.length ? parts.join(', ') : empty, closed: !parts.length });
    }
    return rows;
  }

  // Pickup = the store's own hours.
  function pickupRows(hours) {
    return rowsFor(hours, 'Closed', function (p) {
      if (p.close === null) return 'Open 24 hours';
      return fmtMin(p.open) + ' - ' + fmtMin(p.close);
    });
  }

  // Delivery = open + 2 h until min(close, 7 pm), 5 pm on Sundays.
  function deliveryRows(hours) {
    return rowsFor(hours, 'No delivery', function (p, d) {
      var start = p.open + DELIVERY_LAG;
      var end = Math.min(p.close === null ? 1440 : p.close, d === 0 ? DELIVERY_END_SUNDAY : DELIVERY_END);
      if (start >= end) return '';
      return fmtMin(start) + ' - ' + fmtMin(end);
    });
  }

  // Feed record for a city key: exact `city` field first, else the key
  // inside the Google name or address (the strip's matching, same order).
  function storeFor(stores, key) {
    var i, s, hay;
    if (!Array.isArray(stores)) return null;
    for (i = 0; i < stores.length; i++) {
      s = stores[i];
      if (s && s.city && String(s.city).toLowerCase() === key) return s;
    }
    for (i = 0; i < stores.length; i++) {
      s = stores[i];
      if (!s) continue;
      hay = (String(s.name || '') + ' ' + String(s.address || '')).toLowerCase();
      if (hay.indexOf(key) !== -1) return s;
    }
    return null;
  }

  var pure = {
    mins: mins, fmt: fmt, fmtMin: fmtMin, status: status, storeDay: storeDay,
    periods: periods, pickupRows: pickupRows, deliveryRows: deliveryRows,
    storeFor: storeFor, DELIVERY_NOTE: DELIVERY_NOTE, CITY: CITY
  };
  if (typeof module === 'object' && module && module.exports) module.exports = pure;
  if (typeof document === 'undefined' || typeof window === 'undefined' || !window.fetch) return;

  /* ---- DOM ------------------------------------------------------------ */
  var KINDS = ['pickup', 'delivery'];
  var LEAD_RE = {
    pickup: /^\s*Our in-store pickup hours are as follows:/i,
    delivery: /^\s*Our Local Delivery hours are as follows:/i
  };
  var WEEKDAY_RE = /^\s*(?:sunday|monday|tuesday|wednesday|thursday|friday|saturday)\b/i;
  var live = [];   // rendered .xg-livehours boxes, repainted on the minute tick

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function buildStatus() {
    var line = el('div', 'xg-livehours__status');
    var dot = el('i', 'xg-livehours__dot');
    dot.setAttribute('aria-hidden', 'true');
    var text = el('span', 'xg-livehours__text');
    text.appendChild(el('span', 'xg-livehours__state'));
    text.appendChild(el('span', 'xg-livehours__detail'));
    line.appendChild(dot);
    line.appendChild(text);
    return line;
  }

  function paintStatus(line, st) {
    line.className = 'xg-livehours__status ' + (st.open ? 'is-open' : 'is-closed');
    line.querySelector('.xg-livehours__state').textContent = st.open ? 'Open now' : 'Closed';
    line.querySelector('.xg-livehours__detail').textContent = st.detail ? ' · ' + st.detail : '';
  }

  function buildWeek(rows, today) {
    var dl = el('dl', 'xg-livehours__week'), i, r, row;
    for (i = 0; i < rows.length; i++) {
      r = rows[i];
      row = el('div', 'xg-livehours__row' + (r.day === today ? ' is-today' : '') + (r.closed ? ' is-closed' : ''));
      row.setAttribute('data-day', String(r.day));
      row.appendChild(el('dt', 'xg-livehours__day', r.name));
      row.appendChild(el('dd', 'xg-livehours__time', r.text));
      dl.appendChild(row);
    }
    return dl;
  }

  // The block for one kind: status pill + week for pickup, week + note
  // for delivery. Null when the record has nothing trustworthy to show.
  function buildBox(kind, store, now) {
    if (!periods(store.hours).length) return null;
    var st = status(store, now);
    if (!st) return null;
    var today = storeDay(store, now);
    var box = el('div', 'xg-livehours xg-livehours--' + kind);
    if (kind === 'pickup') {
      var line = buildStatus();
      paintStatus(line, st);
      box.appendChild(line);
      box.appendChild(buildWeek(pickupRows(store.hours), today));
    } else {
      box.appendChild(buildWeek(deliveryRows(store.hours), today));
      box.appendChild(el('div', 'xg-livehours__note', DELIVERY_NOTE));
    }
    return box;
  }

  // Marker path: data attribute, then id, then class; first match only.
  function markerFor(kind) {
    return document.querySelector('[data-xg-hours="' + kind + '"]') ||
      document.getElementById('xg-hours-' + kind) ||
      document.querySelector('.xg-hours-' + kind);
  }

  function fillMarker(marker, box) {
    while (marker.firstChild) marker.removeChild(marker.firstChild);
    marker.appendChild(box);
    marker.setAttribute('data-xg-hours-live', 'true');
  }

  // Legacy path. Filler = the <br>, <meta> and whitespace the editor left
  // around the weekday spans (a comment counts too).
  function isFiller(n) {
    if (n.nodeType === 3) return !/\S/.test(n.nodeValue);
    if (n.nodeType === 1) return n.nodeName === 'BR' || n.nodeName === 'META';
    return true;
  }
  function isWeekdaySpan(n) {
    return n.nodeType === 1 && n.nodeName === 'SPAN' && WEEKDAY_RE.test(n.textContent || '');
  }
  // The weekday run inside a paragraph, or null unless it is unmistakably
  // the typed hours block: the leading text (everything before the first
  // weekday span) is the kind's sentence, at least five weekday spans,
  // and nothing but filler between the first and the last of them.
  function scanLegacy(p, kind) {
    if (p.getAttribute('data-xg-hours-live') === 'true') return null;
    var kids = p.childNodes, first = -1, last = -1, count = 0, lead = '', i, n;
    for (i = 0; i < kids.length; i++) {
      n = kids[i];
      if (isWeekdaySpan(n)) { if (first < 0) first = i; last = i; count++; }
      else if (first < 0) lead += n.nodeType === 3 ? n.nodeValue : (n.textContent || '');
    }
    if (count < 5 || !LEAD_RE[kind].test(lead)) return null;
    for (i = first; i <= last; i++) {
      if (!isWeekdaySpan(kids[i]) && !isFiller(kids[i])) return null;
    }
    return { first: first, last: last };
  }
  function legacyFor(kind) {
    var ps = document.querySelectorAll('.shopify-policy__body p, .xg-page__body p'), i;
    for (i = 0; i < ps.length; i++) if (scanLegacy(ps[i], kind)) return ps[i];
    return null;
  }
  // Sentence stays in the paragraph (trailing filler stripped), the run
  // goes, the block lands as the next sibling, and what followed the run
  // moves into a new paragraph after the block.
  function spliceLegacy(p, kind, box) {
    var scan = scanLegacy(p, kind);
    if (!scan || !p.parentNode) return false;
    var kids = p.childNodes, tail = [], after = null, i;
    for (i = scan.last + 1; i < kids.length; i++) {
      if (!tail.length && isFiller(kids[i])) continue;
      tail.push(kids[i]);
    }
    for (i = scan.last; i >= scan.first; i--) p.removeChild(kids[i]);
    if (tail.length) {
      after = document.createElement('p');
      for (i = 0; i < tail.length; i++) after.appendChild(tail[i]);
    }
    while (p.lastChild && isFiller(p.lastChild)) p.removeChild(p.lastChild);
    if (p.lastChild && p.lastChild.nodeType === 3) p.lastChild.nodeValue = p.lastChild.nodeValue.replace(/\s+$/, '');
    p.parentNode.insertBefore(box, p.nextSibling);
    if (after) box.parentNode.insertBefore(after, box.nextSibling);
    p.setAttribute('data-xg-hours-live', 'true');
    return true;
  }

  // One target per kind: a marker wins; a marker already filled stops the
  // search (no legacy fallback behind it); else the legacy paragraph.
  var targets = [], i, kind, marker, para;
  for (i = 0; i < KINDS.length; i++) {
    kind = KINDS[i];
    marker = markerFor(kind);
    if (marker) {
      if (marker.getAttribute('data-xg-hours-live') !== 'true') targets.push({ kind: kind, marker: marker });
      continue;
    }
    para = legacyFor(kind);
    if (para) targets.push({ kind: kind, legacy: para });
  }
  if (!targets.length) return;

  // Minute tick: only the status line and the today highlight change.
  function tick(store) {
    var now = Date.now(), st = status(store, now), today = String(storeDay(store, now));
    var i, j, line, rows;
    for (i = 0; i < live.length; i++) {
      line = live[i].querySelector('.xg-livehours__status');
      if (line && st) paintStatus(line, st);
      rows = live[i].querySelectorAll('.xg-livehours__row');
      for (j = 0; j < rows.length; j++) {
        if (rows[j].getAttribute('data-day') === today) rows[j].classList.add('is-today');
        else rows[j].classList.remove('is-today');
      }
    }
  }

  try {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var tmo = ctl ? setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 7000) : null;
    fetch(WORKER + '/stores.json', { signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        if (tmo) clearTimeout(tmo);
        if (!d || d.ok !== true || !Array.isArray(d.stores) || !d.stores.length) return;
        var store = storeFor(d.stores, CITY);
        if (!store) return;
        var now = Date.now(), i, t, box;
        for (i = 0; i < targets.length; i++) {
          try {
            t = targets[i];
            box = buildBox(t.kind, store, now);
            if (!box) continue;
            if (t.marker) { fillMarker(t.marker, box); live.push(box); }
            else if (spliceLegacy(t.legacy, t.kind, box)) live.push(box);
          } catch (e) {}
        }
        if (!live.length) return;
        // The state flips on the minute; recompute from the cached feed,
        // never refetch. A tab left open overnight catches up as soon as
        // it is looked at again.
        setInterval(function () { try { tick(store); } catch (e) {} }, 60000);
        document.addEventListener('visibilitychange', function () { if (!document.hidden) { try { tick(store); } catch (e) {} } });
      })
      .catch(function () { if (tmo) clearTimeout(tmo); });
  } catch (err) {}
})();